var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldEmojiHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm2.57 6.26c0 1.04-.84 1.88-1.88 1.88s-1.88-.86-1.88-1.89c0-1.03.85-1.87 1.88-1.87 1.03 0 1.88.84 1.88 1.88zM7.12 14.2c0-.7.57-1.28 1.27-1.28h7.2c.7 0 1.27.57 1.27 1.28.02 2.69-2.17 4.88-4.86 4.88-2.69 0-4.88-2.19-4.88-4.88zm6.5-5.96c0-1.04.84-1.88 1.88-1.88s1.88.84 1.88 1.88-.85 1.88-1.88 1.88c-1.03 0-1.88-.84-1.88-1.88z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldEmojiHappy);
export default __webpack_public_path__ + "static/media/vuesax-bold-emoji-happy.180105d14795628b4d8fd4432c6ab803.svg";
export { ForwardRef as ReactComponent };